<template>
  <div class="ticket-state" :class="{'ticket-state_blink': hasBlink}">
    <div class="ticket-state__text">
      {{ item.ticketNumber }}
    </div>
  </div>
</template>

<script>
  import { mapState } from 'vuex'

  export default {
    name: 'TicketState',
    props: {
      item: {
        type: Object,
        required: false
      },
      type: {
        type: String
      }
    },
    computed: {
      ...mapState({
        playListSpeakId: state => state.playlist.speakId
      }),
      hasBlink () {
        return this.playListSpeakId === this.item.id
      }
    },
    data () {
      return {
        blink: false
      }
    }
  }
</script>
